export const NEW_CATEGORY = 'NEW_CATEGORY';
export const RECEIVE_CATEGORY_DATA = 'RECEIVE_CATEGORY_DATA';
export const RESET_SORT_AND_FACETS = 'RESET_SORT_AND_FACETS';

export function newCategory(categoryId, searchTerm) {
    return {
        type: NEW_CATEGORY,
        payload: {
            direction: null,
            requestType: NEW_CATEGORY,
            requestStatus: 'MAKING_REQUEST',
            categoryId: categoryId,
            searchTerm: searchTerm,
            isSearch: !!searchTerm,
            queryParams: {}
        }
    };
}

export function resetSortAndFacets() {
    return {
        type: RESET_SORT_AND_FACETS
    };
}
